import styled from 'styled-components/macro';
import { FlexNoAlign } from '../../../../../shared-styles/flex';

export const ActivityContainer = styled.div`
  display: grid;
  padding: ${(props) => props.theme.spacing(15)} ${(props) => props.theme.spacing(20)};
  grid-template-columns: 35px auto auto;
  grid-template-rows: auto auto;
  background-color: ${(props) => (props.backgroundWarn ? props.theme.palette.custom.lightRed : '')};
`;

export const IconContainer = styled.div`
  height: 100%;
  width: 25px;
  grid-column: 1 / 2;
  grid-row: 1 / span 2;
`;

export const ActivityHeader = styled.span`
  font-size: ${(props) => props.theme.typography.sizes.small};
`;

export const ActivityDescriptor = styled.span`
  font-size: ${(props) => props.theme.typography.sizes.small};
  font-weight: ${(props) => props.theme.typography.weight.bold};
  color: ${(props) => props.theme.palette.black[100]};
`;

export const ActivityTimeStamp = styled.p`
  color: ${(props) => props.theme.palette.darkGray[75]};
  text-align: right;
  margin-top: 0;
  padding-top: 0;
  grid-column: 3 / 3;
  margin-top: ${(props) => (props.canComment ? props.theme.spacing(20) : 0)};
  text-wrap: none;
  overflow: show;
`;

export const ContentContainer = styled.div`
  padding-top: ${(props) => props.theme.spacing(5)};
  padding-right: ${(props) => props.theme.spacing(20)};
  padding-bottom: 0;
  grid-column-start: 2; 
  grid-column-end: 4; 
  font-size: ${(props) => props.theme.typography.sizes.small};
`;

export const VerticalAlign = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  grid-column: 2 / 3;
`;

export const CommentControlContainer = styled.div`
  ${FlexNoAlign}
  grid-column: 2 / 2;
  margin-top: ${(props) => (props.canComment ? props.theme.spacing(20) : 0)};
  gap: ${(props) => props.theme.spacing(10)};
  cursor: pointer;
`;

export const CommentIcon = styled.img`
  cursor: pointer;
  width: 17px;
  height: 17px;
  margin-top: 2px;
`;

export const CommentCount = styled.p`
  margin: 0;
`;

export const ResolvedPill = styled.span`
  display:inline-flex;    
  background-color: ${(props) => props.theme.palette.custom.resolvedYellow};
  font-size: ${({ theme }) => theme.typography.sizes.small};
  border-radius: 10px;
  padding: ${(props) => props.theme.spacing(5)} ${(props) => props.theme.spacing(12)}; 
  justify-self: flex-end;
  width: max-content;
  height: fit-content;
  font-weight: ${(props) => props.theme.typography.weight.semiBold};
`;
